import * as styles from './styles/styles.module.scss';

export default function ReviewCount({ className = undefined, count }) {
  const classes = [styles.count];
  if (className) {
    classes.push(className);
  }
  if (!count) {
    return null;
  }
  return <span className={classes.join(' ')}>{`(${count})`}</span>;
}
